module.exports = __webpack_public_path__ + "static/media/Overview_active.8f366a3c.svg";